import React, {useEffect, useState } from "react";
import {  
    getLeave, 
    submitLeave, 
    getLoggedInUser, 
    declineLeave, 
    disapproveLeave, 
    reviewLeave, 
    approveLeave, 
    handoverNote 
} from "../../utils/helper";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Loader from "../../utils/Loader";
import { useParams, useHistory } from "react-router-dom";
import { alertError, alertSuccess } from "../../utils/alerts";

const INIT_STATE = {
    leave_type: "",
    year: "",
    month: "",
    start_date: "",
    end_date: "",
    employee_team:"",
    employee: "",
    relief_officer:"",
    createdAt:"",
    status: "",
    handoverdoc:"",
};

export default function ViewLeave() {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [r_loading, setRLoading] = useState(false);
    const [a_loading, setALoading] = useState(false);
    const [ds_loading, setDsLoading] = useState(false);
    const [de_loading, setDeLoading] = useState(false);
    const [state, setState] = useState(INIT_STATE);
    const [leave, setLeave] = useState(null);
    const [profile, setProfile] = useState("");
    const TOKEN = localStorage.getItem("kloka:token:data");
    const [handoverdoc, setHandoverFile] = useState("");

    useEffect(()=>{
        if(TOKEN){
            getLoggedInUser(TOKEN).then((res) => {
                setProfile(res.data.data);
            });
        }
    }, [TOKEN]);

    useEffect(() => {
        if(id){
            getLeave(id)
                .then((res) => {
                    if(res.data.success){
                        setLeave(res.data.data);
                    }else {
                        alertError(res.data.message);
                    }
                })
                .catch((err) => {
                    console.log(err?.response?.data?.error)
                });
        }
        setLoading(false);
    }, [id]); 


    useEffect(() => {
        setState((prev) => ({
            ...prev,
            leave_type: (leave && leave.leave_type) || "",
            year: (leave && leave.year) || "",
            start_date: (leave && leave.start_date) || "",
            end_date: (leave && leave.end_date) || "",
            employee_team: (leave && leave.employee_team) || "",
            employee: (leave && leave.employee) || "",
            relief_officer: (leave && leave.relief_officer) || "",
            status: (leave && leave.status) || "",
            createdAt: (leave && leave.createdAt) || "",
            no_of_days: (leave && leave.no_of_days) || "",            
            handoverdoc: (leave && leave.handoverdoc) || "",
            
            reviewComment: (leave && leave.reviewComment) || "",
            reviewedBy: (leave && leave.reviewedBy) || "",
            reviewedAt: (leave && leave.reviewedAt) || "",
            
            declineComment: (leave && leave.declineComment) || "",
            declinedBy: (leave && leave.declinedBy) || "",
            declinedAt: (leave && leave.declinedAt) || "",

            disapproveComment: (leave && leave.disapproveComment) || "",
            disapprovedBy: (leave && leave.disapprovedBy) || "",
            disapprovedAt: (leave && leave.disapprovedAt) || "",

            approveComment: (leave && leave.approveComment) || "",
            approvedBy: (leave && leave.approvedBy) || "",
            approvedAt: (leave && leave.approvedAt) || "",

        }));
    }, [leave]);

    useEffect(() => {
        if(handoverdoc){
            setState((prev) => ({
                ...prev,
                handoverdoc: handoverdoc,
            }));
        }
    }, [handoverdoc]);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }
    
    // vivian 6479f5a15b006cb0e494327b
    // psm 6479f5fa5b006cb0e4943283
    const isMine = (state && profile) ? state.employee?._id === profile._id : false;
    const isTeamHead = (state && state.employee_team?.team_head) ? state.employee_team?.team_head === profile._id : false;
    const isPSMHead = (state && profile) ? profile._id === "6479f5fa5b006cb0e4943283" : false;
    const isVivian = (state && profile) ? profile._id === "6479f5a15b006cb0e494327b" : false;
    const isByTeamHead = (state && state.employee_team?.team_head) ? state.employee_team?.team_head === state.employee._id : false;

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { ...state, id}
        if(data.leave_type && data.employee){
            setLoading(true);
            submitLeave(data, id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    history.goBack();
                })
                .catch((err) => {
                    alertError(err.response.data.error);
                    setLoading(false);
                });
        }
    };

    const handleReview = async (e) => {
        e.preventDefault();
        const data = { comment: state.reviewComment, id };
        if(id && data.comment){
            setRLoading(true);
            reviewLeave(data, id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setRLoading(false);
                    window.location.reload()
                })
                .catch((err) => {
                    alertError(err?.response?.data?.error);
                    setRLoading(false);
                });
        }
    };

    const handleDecline = async (e) => {
        e.preventDefault();
        const data = { comment: state.declineComment, id };
        if(id && data.comment){
            setDeLoading(true);
            declineLeave(data, id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setDeLoading(false);
                    window.location.reload()
                })
                .catch((err) => {
                    alertError(err?.response?.data?.error);
                    setDeLoading(false);
                });
        }
    };

    const handleApprove = async (e) => {
        e.preventDefault();
        const data = { comment: state.approveComment, id };
        if(id && data.comment){
            setALoading(true);
            approveLeave(data, id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setALoading(false);
                    window.location.reload()
                })
                .catch((err) => {
                    alertError(err?.response?.data?.error);
                    setALoading(false);
                });
        }
    };

    const handleDisapprove = async (e) => {
        e.preventDefault();
        const data = { comment: state.disapproveComment, id };
        if(id && data.comment){
            setDsLoading(true);
            disapproveLeave(data, id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setDsLoading(false);
                    window.location.reload()
                })
                .catch((err) => {
                    alertError(err?.response?.data?.error);
                    setDsLoading(false);
                });
        }
    };

    const handlehandover = async (e) => {
        e.preventDefault();
        const data = { ...state, id}
        if(data.leave_type && data.employee && data.handoverdoc){
            setLoading(true);
            handoverNote(data, id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    history.goBack();
                })
                .catch((err) => {
                    alertError(err.response.data.error);
                    setLoading(false);
                });
        }
    };


    return (
        <>  
            {/* {!loading && kpd ? 
            <div className="spur-card-menu">
                <button type="button" data-toggle="modal" data-target="#modal" className="pull-right btn topbtn btn-primary">ADD KPI</button>
            </div> : null } */}

            <h1 className="dash-title"><Link to="/leave/requests" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">View Leave</div>
                            <div className="spur-card-menu">
                                <span className={state.status === "draft" ? 'btn myybtn btn-primary' : (
                                    state.status === "submitted" ? 'btn myybtn btn-warning' : (
                                        state.status === "reviewed" ? 'btn myybtn btn-success' : (
                                            (state.status === "approved" || state.status === "document") ? 'btn myybtn btn-success' : (
                                                state.status === "disapproved" ? 'btn myybtn btn-danger' : null
                                            )
                                        )
                                    )
                                )}>{state.status}</span>
                                {state.status === "document" ?
                                    <button type="button" data-toggle="modal" data-target="#docmodal" 
                                    style={{marginTop: 3, marginLeft: 10}}
                                        className="pull-right btn topbtn btn-primary">View Document
                                    </button> 
                                : null}
                            </div>                            
                        </div>
                        
                        {!loading && leave ? <>
                        <div className="card-body">
                            <div className="my_profile">
                                <div className="row">
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Employee: <span>*</span></label>
                                        <input name="employee" type="text" placeholder="Employee" className="form-control" required 
                                        defaultValue={(state.employee?.first_name && state.employee?.last_name) ? 
                                            `${state.employee?.first_name && state.employee?.first_name} ${state.employee?.last_name && state.employee?.last_name}` : ""} 
                                            disabled />
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Team: <span>*</span></label>
                                        <input name="team" type="text" placeholder="Team" className="form-control" required 
                                            defaultValue={state.employee_team?.team_name || ""} 
                                            disabled />
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Leave Type: <span>*</span></label>
                                        <input name="leave_type" type="text" placeholder="Leave Type" className="form-control" required 
                                            defaultValue={state.leave_type || ""} 
                                            disabled />
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Start Date: <span>*</span></label>
                                        <input name="team" type="text" placeholder="Start Date" className="form-control" required 
                                            defaultValue={state.start_date || ""} disabled />
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">End Date: <span>*</span></label>
                                        <input name="team" type="text" placeholder="End Date" className="form-control" required 
                                            defaultValue={state.end_date || ""} disabled />
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Number of Day(s): <span>*</span></label>
                                        <input name="no_of_days" type="text" placeholder="Number of Day(s)" className="form-control" required 
                                            defaultValue={state.no_of_days || ""} 
                                            disabled />
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Relief Officer: <span>*</span></label>
                                        <input name="relief_officer" type="text" placeholder="Relief Officer" className="form-control" required 
                                            defaultValue={(state.relief_officer?.first_name && state.relief_officer?.last_name) ? 
                                                `${state.relief_officer?.first_name && state.relief_officer?.first_name} ${state.relief_officer?.last_name && state.relief_officer?.last_name}` : ""} 
                                            disabled 
                                        />
                                    </div>
                                    {((state.status === "approved") && isMine) ? <>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Upload Handover Document: <span>*</span></label>
                                        <input name="handoverdoc" type="file" placeholder="Handover Document" className="form-control" required 
                                            onChange={(e) => {setHandoverFile(e.target.files[0]);}} 
                                        />
                                    </div>
                                    <div className="col-md-12 col-sm-12 text-center">
                                        
                                    </div> </> : null }
                                </div>
                            </div>
                        </div>
                        
                        {(isMine && state.status === "draft") ? (
                        <div className="card-header" style={{borderBottom:'none', borderTop:'1px solid #aaa'}}>
                            <div className="card-body">
                                <div className="col-md-12 col-sm-12 text-center">
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary" 
                                        disabled={loading}
                                        onClick={handleSubmit} 
                                    >
                                        SUBMIT LEAVE
                                    </button>
                                </div>
                            </div>
                        </div>
                        ) : null}

                        {(isMine && state.status === "approved") ? (
                        <div className="card-header" style={{borderBottom:'none', borderTop:'1px solid #aaa'}}>
                            <div className="card-body">
                                <div className="col-md-12 col-sm-12 text-center">
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary" 
                                        disabled={loading}
                                        onClick={handlehandover} 
                                    >
                                            UPLOAD HANDOVER NOTE
                                    </button>
                                </div>
                            </div>
                        </div>
                        ) : null}

                        {isTeamHead && (!isByTeamHead && state.status === "submitted") ? (
                            <div className="card-header" style={{borderBottom:'none', borderTop:'1px solid #aaa'}}>
                                <div className="card-body">
                                    <div className="col-md-12 col-sm-12 text-center">
                                        <div className="btn-group">
                                            <button 
                                                type="button" 
                                                className="btn btn-success" 
                                                disabled={loading}
                                                data-toggle="modal" data-target="#modal"
                                            >
                                                    REVIEW LEAVE REQUEST
                                                </button>
                                            <button 
                                                type="submit" 
                                                className="btn btn-danger" 
                                                disabled={loading}
                                                data-toggle="modal" data-target="#decline"
                                                >
                                                    DECLINE LEAVE REQUEST
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        {(isByTeamHead && (isVivian && state.status === "submitted")) ? (
                            <div className="card-header" style={{borderBottom:'none', borderTop:'1px solid #aaa'}}>
                                <div className="card-body">
                                    <div className="col-md-12 col-sm-12 text-center">
                                        <div className="btn-group">
                                            <button 
                                                type="button" 
                                                className="btn btn-success" 
                                                disabled={loading}
                                                data-toggle="modal" data-target="#modal"
                                            >
                                                    REVIEW LEAVE REQUEST
                                                </button>
                                            </div>
                                            <button 
                                                type="submit" 
                                                className="btn btn-danger" 
                                                disabled={loading}
                                                data-toggle="modal" data-target="#decline"
                                            >
                                                    DECLINE LEAVE REQUEST
                                            </button>
                                        </div>
                                </div>
                            </div>
                        ) : null}

                        {(isPSMHead && state.status === "reviewed") ? (
                            <div className="card-header" style={{borderBottom:'none', borderTop:'1px solid #aaa'}}>
                                <div className="card-body">
                                    <div className="col-md-12 col-sm-12 text-center">
                                        <div className="btn-group">
                                            <button 
                                                type="button" 
                                                className="btn btn-success" 
                                                disabled={loading}
                                                data-toggle="modal" data-target="#approve"
                                            >
                                                    APPROVE LEAVE REQUEST
                                                </button>
                                            </div>
                                            <button 
                                                type="submit" 
                                                className="btn btn-danger" 
                                                disabled={loading}
                                                data-toggle="modal" data-target="#disapprove"
                                            >
                                                    DISAPPROVE LEAVE REQUEST
                                            </button>
                                        </div>
                                </div>
                            </div>
                        ) : null}
                            
                        </> :  <Loader /> }
                    </div> 
                </div>
            </div>


            <div id="modal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">REVIEW LEAVE REQUEST</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Comment <span>*</span></label>
                                    <textarea cols="33" rows="3" name="reviewComment" className="form-control" required placeholder="Comment" 
                                        onChange={handleChange} defaultValue={state.reviewComment || ""} ></textarea>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={r_loading}
                                        onClick={handleReview} >
                                            {r_loading ? <i className="fa fa-spinner fa-spin"></i> : "SUBMIT REVIEW"} 
                                        </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

            <div id="decline" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">DECLINE LEAVE REQUEST</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Comment <span>*</span></label>
                                    <textarea cols="33" rows="3" name="declineComment" className="form-control" required placeholder="Comment" 
                                        onChange={handleChange} defaultValue={state.declineComment || ""} ></textarea>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={de_loading}
                                        onClick={handleDecline} >
                                            {de_loading ? <i className="fa fa-spinner fa-spin"></i> : "DECLINE"} 
                                        </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 


            <div id="approve" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">APPROVE LEAVE REQUEST</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Comment <span>*</span></label>
                                    <textarea cols="33" rows="3" name="approveComment" className="form-control" required placeholder="Comment" 
                                        onChange={handleChange} defaultValue={state.approveComment || ""} ></textarea>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={a_loading}
                                        onClick={handleApprove} >
                                            {a_loading ? <i className="fa fa-spinner fa-spin"></i> : "APPROVE"} 
                                        </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

            <div id="disapprove" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">APPROVE LEAVE REQUEST</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Comment <span>*</span></label>
                                    <textarea cols="33" rows="3" name="disapproveComment" className="form-control" required placeholder="Comment" 
                                        onChange={handleChange} defaultValue={state.disapproveComment || ""} ></textarea>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={ds_loading}
                                        onClick={handleDisapprove} >
                                            {ds_loading ? <i className="fa fa-spinner fa-spin"></i> : "DISAPPROVE"} 
                                        </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

            <div id="docmodal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">HANDOVER DOCUMENT</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <object
                                data={state.handoverdoc}
                                className="handoverdoc"
                            >
                                <p>
                                    Your Browser doesn't have a PDF Plugin. Instead you can view it on your browser <a href={state.handoverdoc} download rel="noreferrer" target="_blank">View</a>
                                </p>
                            </object>
                        </div>
                    </div>
                </div>
            </div> 

        </>
    );
}
